import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import dayjs from "dayjs";
import { CalenderIcon } from "components/atoms/Icon";
import { Button, Typography } from "components/atoms";
import { MonthNavigatorOnboardingForm } from "../MonthNavigatorOnboardingForm";
import "./index.scss";

interface IProps {
  placeholder: string;
  setDateSelection: any;
  defaultSelected: any;
  inputFormat: any;
  question: any;
  styles?: string;
  handleReschedule?: any;
  isDisableFutureDates?: boolean;
  resetOnCancel?: () => void;
}

const daysofTheWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const DatePickerOnboardingForm = ({
  placeholder,
  styles,
  setDateSelection,
  inputFormat,
  defaultSelected,
  handleReschedule,
  question,
  isDisableFutureDates,
  resetOnCancel,
}: IProps) => {
  const [isShowItems, setIsShowItems] = useState<boolean>(false);

  const [currentMonth, setCurrentMonth] = useState(dayjs());

  const [mobileDay, setMobileDay] = useState<any>();

  const [isAgreeToTestDateGuideline, setIsAgreeToTestDateGuideline] = useState<
    "idle" | "yes" | "no"
  >("idle");

  const calendarViewRefOnbForm = useRef<HTMLDivElement>(null);

  const handleShowList = (event: any) => {
    event.preventDefault();
    setIsShowItems(!isShowItems);
  };

  const handleCancel = () => {
    setIsShowItems((prev) => false);
    if (resetOnCancel) {
      resetOnCancel();
    }
  };

  const handleApply = () => {
    setDateSelection(dayjs(mobileDay).format());
    setIsShowItems(false);
    if (handleReschedule) {
      handleReschedule(mobileDay);
    }
  };

  const handleItemClick = () => {
    setIsShowItems(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      calendarViewRefOnbForm.current &&
      !calendarViewRefOnbForm.current.contains(event.target as Node)
    ) {
      setIsShowItems(false);
    }
  };

  const handleClickYes = () => {
    setIsAgreeToTestDateGuideline("yes");
    setMobileDay(undefined);
  };

  const handleClickNo = () => {
    setIsAgreeToTestDateGuideline("no");
    handleApply();
  };

  const incrementMonth = () => {
    setCurrentMonth((prevMonth) => prevMonth.add(1, "month"));
  };

  const decrementMonth = () => {
    setCurrentMonth((prevMonth) => prevMonth.subtract(1, "month"));
  };

  const handleMobileDayClick = (clickDay: any) => {
    setMobileDay(clickDay);
    // setDateSelection(clickDay);
  };

  const mobileRenderBody = (isDisableFutureDates?: boolean) => {
    const monthStart = currentMonth.startOf("month");
    const monthEnd = currentMonth.endOf("month");
    const startDate = monthStart.startOf("week");
    const endDate = monthEnd.endOf("week");

    const weeks = [];
    let week = [];

    for (let day = startDate; day.isBefore(endDate); day = day.add(1, "day")) {
      if (day.isSameOrAfter(monthStart) && day.isSameOrBefore(monthEnd)) {
        week.push({
          dateNumber: day,
          inCurrentMonth: true,
        });
      } else {
        week.push({
          dateNumber: day,
          inCurrentMonth: false,
        });
      }
      if (day.day() === 6) {
        weeks.push(week);
        week = [];
      }
    }

    return weeks.map((week, i) => (
      <tr key={i}>
        {week.map((day, j) => (
          <td key={j}>
            <div
              className={classNames({
                "tbody-td-parent-wrapper": true,
                "blur-date-number": day.inCurrentMonth === false,
              })}
            >
              <div
                className={classNames({
                  "header-date-number-wrapper": true,
                  "disable-dates":
                    isDisableFutureDates === true &&
                    dayjs(day.dateNumber).format() > dayjs().format(),
                })}
                onClick={() => {
                  if (
                    isDisableFutureDates === true &&
                    dayjs(day.dateNumber).format() > dayjs().format()
                  ) {
                    return;
                  } else {
                    handleMobileDayClick(day.dateNumber);
                  }
                }}
              >
                <Typography
                  variant="h8Med"
                  label={day.dateNumber.format("D")}
                  styles={
                    day.inCurrentMonth === true &&
                    day.dateNumber.format("DD/MM/YYYY") ===
                      dayjs().format("DD/MM/YYYY")
                      ? "today-date-typography-custom-style day-number-custom-style"
                      : "date-typography-custom-style day-number-custom-style"
                  }
                />
              </div>
            </div>
          </td>
        ))}
      </tr>
    ));
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={calendarViewRefOnbForm}
      className={classNames("date-picker-wrapper", "date-picker-onb-form", {
        [`${styles}`]: styles,
      })}
    >
      <div
        className={classNames("selected-item-wrapper")}
        onClick={handleShowList}
      >
        <div className={classNames("selected-item")}>
          <p>
            {defaultSelected
              ? // ? dayjs(defaultSelected).format(inputFormat)
                dayjs(defaultSelected).format(inputFormat)
              : placeholder}
          </p>
        </div>

        <div
          className={classNames(
            "date-picker-onb-form-icon",
            isShowItems && "date-picker-onb-form-icon-hide"
          )}
        >
          <CalenderIcon color="white" />
        </div>
      </div>

      {isShowItems && (
        <div className={classNames("date-picker-onb-form-item-wrapper")}>
          <div className="date-picker-onb-form-title-wrapper">
            <Typography
              label="Select your target test date:"
              variant="h6Bold"
              styles="target-test-date-cutom-style"
            />
          </div>
          <div className="date-picker-onb-form-body-wrapper">
            {question && question.guaranteeGuidelineTitle ? (
              <Typography
                label={question.guaranteeGuidelineTitle}
                variant="h6Book"
                styles="guideline-title-custom-style"
              />
            ) : null}
            <MonthNavigatorOnboardingForm
              incrementMonth={incrementMonth}
              decrementMonth={decrementMonth}
              text={currentMonth.format("MMMM YYYY")}
            />
            <div className="dates-wrapper-onb-form">
              <table className="study-table-mobile-onb-form" rules="none">
                <thead>
                  <tr>
                    {daysofTheWeek.map((weekday, index) => (
                      <th key={index}>
                        <Typography
                          variant="h8Med"
                          label={weekday.substring(0, 3)}
                          styles={
                            weekday.substring(0, 3) === "Sun"
                              ? "day-name-custom-style-gray"
                              : "day-name-custom-style-black"
                          }
                        />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>{mobileRenderBody(isDisableFutureDates)}</tbody>
              </table>
            </div>
            {question &&
            question.guaranteeGuidelineCondition &&
            question.PSOTagetTestDate &&
            mobileDay !== undefined &&
            dayjs(mobileDay).isAfter(dayjs(question.PSOTagetTestDate)) ? (
              <div className="guaranee-condition-wrapper">
                <Typography
                  label={question.guaranteeGuidelineCondition}
                  variant="h6Book"
                  styles="guarantee-condition-custom-style"
                />
                <div className={classNames("btn-wrapper-onb-form")}>
                  <Button
                    icon={false}
                    label="No"
                    type="online"
                    onClick={handleClickNo}
                  />
                  <Button
                    icon={false}
                    label="Yes"
                    type="score"
                    onClick={handleClickYes}
                  />
                </div>
              </div>
            ) : (question &&
                question.guaranteeGuidelineCondition &&
                question.PSOTagetTestDate &&
                mobileDay !== undefined &&
                dayjs(mobileDay).isSameOrBefore(
                  dayjs(question.PSOTagetTestDate)
                )) ||
              (!question.guaranteeGuidelineCondition &&
                !question.PSOTagetTestDate &&
                mobileDay !== undefined) ? (
              <div className={classNames("btn-wrapper-onb-form")}>
                <Button
                  icon={false}
                  label="Cancel"
                  type="online"
                  onClick={() => {
                    // setDateSelection(mobileDay);
                    // setIsShowItems(false);
                    handleCancel();
                  }}
                />
                <Button
                  icon={false}
                  label="Confirm"
                  type="score"
                  onClick={() => {
                    // setDateSelection(mobileDay);
                    // setIsShowItems(false);
                    handleApply();
                  }}
                />
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};
